import './vendor';

// Custom select it is call Selectpicker
$('.selectpicker').selectpicker({
	style: 'form-control form-control_icon',
	styleBase: '',
});

// methods is anythins is selected in selectpicker
$('.selectpicker').on('changed.bs.select', function (e, clickedIndex, isSelected, previousValue) {
	if(isSelected) {
		this.nextSibling.classList.add('is-selected');
	} else {
		this.nextSibling.classList.remove('is-selected');
	}
});

// Modal filter call and add class to body
$('#modalFilters').on('show.bs.modal', function (e) {
	let bodyElement = document.querySelector('body');
	bodyElement.classList.add('modal-open-filter');
});
$('#modalFilters').on('hidden.bs.modal', function (e) {
	let bodyElement = document.querySelector('body');
	bodyElement.classList.remove('modal-open-filter');
});

// checkbox all
// $("#select-all").click(function () {
// 	$('input:checkbox').not(this).prop('checked', this.checked);
// });

$("#select-all").change(function () { //"select all" change
	var status = this.checked; // "select all" checked status
	$('.custom-control-input').each(function () { //iterate all listed checkbox items
		this.checked = status; //change ".checkbox" checked status
	});
});

// scroll screen to content to toggle accordion
$('.collapse').on('shown.bs.collapse', function (e) {
	let windowWidth = window.innerWidth;
	if(windowWidth <= 767.5) {
		let $stepsElemntContent = $(this).prev();
		$('html,body').animate({
			scrollTop: ($stepsElemntContent.offset().top + -58)
		}, 500);
	}
});

function removeClassShowAcc () {
	let windowWidth = window.innerWidth;
	if (windowWidth <= 767.5) {
		$('.steps__item_content.show').addClass('steps__item_hide-mobile').removeClass('show');
		$('.steps__item_toggle:first-child .steps__item__link').addClass('collapsed');
	}
	else {
		$('.steps__item_content.steps__item_hide-mobile').addClass('show').removeClass('steps__item_hide-mobile');
		$('.steps__item_toggle:first-child .steps__item__link').removeClass('collapsed');
	}
};


$(function () {
	let resizeWindow = $(window).width();
	removeClassShowAcc();
	$(window).on("resize", function () {
		if (resizeWindow != $(window).width()) {
			removeClassShowAcc();
		}
	});
});

// init slick carousel
$('.slider-for').slick({
	slidesToShow: 1,
	slidesToScroll: 1,
	arrows: false,
	fade: true,
	asNavFor: '.slider-nav'
});
$('.slider-nav').slick({
	slidesToShow: 4,
	slidesToScroll: 1,
	asNavFor: '.slider-for',
	dots: false,
	focusOnSelect: true,
	centerPadding: 0,
	responsive: [
		{
			breakpoint: 991.98,
			settings: {
				arrows: false,
			}
		}
	]
});

// Example starter JavaScript for disabling form submissions if there are invalid fields
(function () {
	'use strict';
	window.addEventListener('load', function () {
		// Fetch all the forms we want to apply custom Bootstrap validation styles to
		let forms = document.getElementsByClassName('needs-validation');
		// Loop over them and prevent submission
		var validation = Array.prototype.filter.call(forms, function (form) {
			form.addEventListener('submit', function (event) {
				if (form.checkValidity() === false) {
					event.preventDefault();
					event.stopPropagation();
				}
				form.classList.add('was-validated');
			}, false);
		});
	}, false);
})();

Inputmask({
	"mask": "+(999) 999-999-999",
}).mask('.form-control_number');
